<template>
  <form-select
    class="special-area-select-v1"
    v-model="val"
    :options="options"
    @change="change"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'special-area-select-v1',
  props: {
    area: { type: Array, default: () => [] },
    value: String,
    lang: String,
    queryObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  model: {
    prop: 'value',
    event: 'setval'
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      }
    }
  },
  data() {
    return {
      options: [],
      index:0,
      changeIndex:0
    }
  },

  methods: {
    arr2Options(arr) {
      var options = []
      if (Array.isArray(arr)) {
        for (var item of arr) {
          options.push({ label: this.$root.convertLangArea(item,this.lang), value: item })
        }
      }

      return options
    },
    change(newVal) {
      this.changeIndex++
      this.$nextTick(() => {
        this.$emit('change', newVal,this.changeIndex)
      })
    }
  },
  watch: {
    queryObj() {
      this.options = this.arr2Options(this.area)
      const currentArea = this.options[0] ? this.options[0].value : ''
      this.val = currentArea
      this.changeIndex++
      this.$nextTick(() => {
        this.$emit('change', currentArea,this.changeIndex)
      })
    }
  }
}
</script>
<style lang="less">
.special-area-select-v1{
  width: 100px;
}
</style>
